<h1 mat-dialog-title>{{ 'properties.detail.editPhonebookContactDialog.title' | translate }}</h1>
<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>
  <div class="form-wrapper mt-3">
    <form [formGroup]="form" (ngSubmit)="onFormSubmit(model)">
      <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
      <div class="row mb-1">
        <div class="col-12 col-md-6 text-left">
          <a mat-button mat-raised-button mat-default (click)="onClose()">{{ 'common.cta.close' | translate }}</a>
        </div> <!-- /.col -->
        <div class="col-12 col-md-6 text-right">
          <mat-spinner-button role="submit" [options]="formBtnOptions" class="btn-elevate">
          </mat-spinner-button>
          <a mat-raised-button color="accent" (click)="onAddCommunication()"
            *ngIf="loggedUser && loggedUserPermissions.includes('canCreateCommunications')"
            matTooltip="{{ 'properties.detail.phonebookTab.newMessageTooltip' | translate }}" class="ml-2">
            {{ 'properties.detail.editPhonebookContactDialog.newMessage' | translate }}
            <mat-icon fontSet="fal" fontIcon="fa-envelope"></mat-icon>
          </a>
        </div> <!-- /.col -->
      </div> <!-- /.row -->
    </form>
  </div> <!-- /.form-wrapper -->
</mat-dialog-content> <!-- mat-dialog-content -->